export interface SymbolLookupInputChangeResolverOptions {
  readonly inputValue: string | undefined;
  readonly lenient: boolean;
  readonly checkSymbol: boolean;
  readonly isValid: boolean;
}

export type SymbolLookupInputChangeResolution =
  | {
    readonly kind: 'empty';
    readonly emitQuery: '';
  }
  | {
    readonly kind: 'text';
    readonly queryValue: string;
    readonly modelAction: 'none' | 'setLenientModel' | 'clearCheckedInvalidModel' | 'setLenientModelThenClearCheckedInvalidModel';
  };

/**
 * Resolves state-transition decisions for SymbolLookupComponent.inputChange().
 *
 * It intentionally preserves the existing ordering semantics:
 * 1) lenient model write can happen first
 * 2) checked-invalid path can clear that model afterward
 */
export function resolveSymbolLookupInputChange(
  options: SymbolLookupInputChangeResolverOptions
): SymbolLookupInputChangeResolution {
  const {
    inputValue,
    lenient,
    checkSymbol,
    isValid
  }: SymbolLookupInputChangeResolverOptions = options;

  if (inputValue === undefined || inputValue === '') {
    return {
      kind: 'empty',
      emitQuery: ''
    };
  }

  return {
    kind: 'text',
    queryValue: inputValue,
    modelAction: lenient && checkSymbol && !isValid
      ? 'setLenientModelThenClearCheckedInvalidModel'
      : lenient
        ? 'setLenientModel'
        : checkSymbol && !isValid
          ? 'clearCheckedInvalidModel'
          : 'none'
  };
}

